import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  tipo: Yup.string().required(),
  comentario: Yup.string().max(500)
})
